export const INT_PLANS = [
    { id:1, name: 'Go' ,price: 49} ,
    { id:2, name: 'Grow',price:99},
    { id:3, name: 'Pro',price:499},
  ];